// These will be used to map to actual claims
// may need to pull this out to make it user configurable

/**
 * Well-known CSX claims
 */
export enum WellKnownClaims {
  /**
   * The department the user works for
   */
  Department = 'department',
  /**
   * The user's title
   */
  Title = 'job_title',
  /**
   * The user's first name
   */
  FirstName = 'first_name',
  /**
   * The user's last name
   */
  LastName = 'last_name',
  /**
   * The display name of the user
   */
  DisplayName = 'name',
  /**
   * The user's email address
   */
  Email = 'email',
  /**
   * The user's phone number
   */
  PhoneNumber = 'phone',
  /**
   * The user's unique identifier
   */
  UserId = 'user_guid',
  /**
   * The user's racf if applicable
   */
  Racf = 'racf',
  /**
   * Whether the user is an internal or external user
   */
  UserSource = 'user_source',
  /**
   * The user type (e.g. union employee, non-union employee, external, etc.)
   */
  UserType ='user_type',
  /**
   * The user's work address
   */
  WorkAddress = 'street_address',
  /**
   * The user's work zip code
   */
  WorkPostalCode = 'postal_code',
  /**
   * The user's work state
   */
  WorkState = 'state',
  /**
   * The user's work city
   */
  WorkCity = 'city',
  /**
   * The roles that the user is authorized for
   */
  Roles = 'roles'
}
